export default function () {
  return {
    professionalFeedback: null,
    errors: {
      professionalFeedback: null,
    },
    successMessage: {
      show: false,
      content: null
    },
    errorMessage: {
      show: false,
      content: null
    }
  }
}
